<div class="skill m-1 pb-3">
  <div class="hability-title">
    <img [src]="hability.language.icon" [alt]="hability.language.name" class="img-thumbnail">
    <h5>{{ hability.language.name }}</h5>
  </div>
  <div *ngFor="let framework of hability.frameworks" class="framework-info">
    <app-progressbar [framework]="framework"></app-progressbar>
  </div>
</div>
